import React, { useState } from 'react';
import CloseIcon from '../../../../../assets/icons/close.svg';
import { AuthenticatedPUTRequest } from '../../../../../utils';

const EditSubjectModal = (props) => {
    const { open, onClose, onError, data } = props;
    const [subject, setSubject] = useState({
        name: data.name,
    });
    const [loading, setLoading] = useState(false);

    const updateSubject = async (values) => {
        setLoading(true);
        try {
            const { success } = await AuthenticatedPUTRequest(`subjects/${data.id}`, {
                subject: values,
            });
            if (success) {
                setLoading(false);
                window.location.reload();
            } else {
                onError('مہرنانی، کچھ غلط ہو گیا ہے۔ دوبارہ کوشش کریں۔');
                setLoading(false);
                onClose();
            }
        } catch (error) {
            onError('مہرنانی، کچھ غلط ہو گیا ہے۔ دوبارہ کوشش کریں۔');
            setLoading(false);
            onClose();
        }
    };

    const onSubmit = () => {
        if (subject.name) {
            setLoading(true);
            updateSubject(subject);
        } else {
            onError('مہرنانی، مضمون کا نام درج کریں');
        }
    };

    return open ? (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 320,
                    maxHeight: 320,
                    width: 576,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto', position: 'relative' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            نئی مضامین کا ریکارڈ درج کریں
                        </h2>

                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20, height: 'calc(100% - 156px)' }}
                    >
                        <div className='form-container'>
                            <label htmlFor='class_name'>
                                مضمون کا نام تبدیل کریں
                                <span className='required'>*</span>
                            </label>
                            <input
                                type='text'
                                id='class_name'
                                name='class_name'
                                value={subject.name}
                                autoFocus='on'
                                onKeyUp={(event) => {
                                    if (event.keyCode === 13) {
                                        setSubject({
                                            ...subject,
                                            name: event.target.value,
                                        });
                                        onSubmit();
                                    }
                                }}
                                onChange={(event) => {
                                    if (event.target.value.length > 0) {
                                        setSubject({
                                            ...subject,
                                            name: event.target.value,
                                        });
                                    } else {
                                        setSubject({ ...subject, name: '' });
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div
                        className='flex justifyEnd alignCenter w-100'
                        style={{ height: 64, paddingLeft: 16 }}
                    >
                        <div className='flex justifyBetween alignCenter'>
                            <div
                                className='flex justifyEnd alignCenter register_button'
                                style={{ margin: '0 8px' }}
                                onClick={() => onSubmit()}
                            >
                                {loading ? (
                                    <div className='custom_loader' />
                                ) : (
                                    <h3>{`محفوظ کریں`}</h3>
                                )}
                            </div>
                            <div
                                className='flex justifyEnd alignCenter delete_button'
                                style={{ margin: '0 8px' }}
                                onClick={onClose}
                            >
                                <h3>{`منسوخ کریں`}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

export default EditSubjectModal;
